import script from "./StepSalary.vue?vue&type=script&setup=true&lang=js"
export * from "./StepSalary.vue?vue&type=script&setup=true&lang=js"

import "./StepSalary.vue?vue&type=style&index=0&id=66a888f3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66a888f3"]])

export default __exports__